export type InvoiceQuantityChoice = {
  mode: 'package' | 'unit';
  unitsPerPackage: number;
};

const PACKAGE_UNITS = /^(?:CX|CAIXA|PC|PCT|PACOTE|FD|FARDO|PACK|CARTELA|CJ)$/i;

export const getInvoicePackageSize = (name: string): number => {
  const description = String(name || '').toUpperCase();
  const volumePack = description.match(/(?:^|\D)(\d{1,3})\s*[X×]\s*\d+(?:[,.]\d+)?\s*(?:ML|L)\b/);
  const countedPack = description.match(/\b(?:CX|CAIXA|PCT|PACOTE|FD|FARDO|PACK)\s*(?:C\/|COM\s*)?(\d{1,3})\s*(?:UN|UND|UNIDADES)?\b/);
  const count = Number(volumePack?.[1] || countedPack?.[1] || 0);
  return count > 1 && count <= 1000 ? count : 0;
};

export const canChooseInvoiceUnits = (name: string, unit: string): boolean =>
  getInvoicePackageSize(name) > 0 || PACKAGE_UNITS.test(String(unit || '').trim());

export const isValidInvoicePackageSize = (value: number): boolean =>
  Number.isInteger(value) && value >= 1 && value <= 1000;

export const convertInvoiceEntry = <T extends { quantity: number; unit: string; unitPrice: number }>(
  item: T,
  choice?: InvoiceQuantityChoice
): T => {
  if (choice?.mode !== 'unit' || !isValidInvoicePackageSize(choice.unitsPerPackage)) return item;
  return {
    ...item,
    quantity: item.quantity * choice.unitsPerPackage,
    unit: 'UN',
    unitPrice: item.unitPrice / choice.unitsPerPackage
  };
};
